export var MIN_WIDTH_MEDIUM = 768;
export var MIN_WIDTH_LARGE = 1000;
export var MIN_WIDTH_EXTRA_LARGE = 1440;
export var SCREEN_MEDIUM = "@media screen and (min-width: ".concat(MIN_WIDTH_MEDIUM, "px)");
export var SCREEN_LARGE = "@media screen and (min-width: ".concat(MIN_WIDTH_LARGE, "px)");
export var SCREEN_EXTRA_LARGE = "@media screen and (min-width: ".concat(MIN_WIDTH_EXTRA_LARGE, "px)");
